import { differenceInCalendarDays } from 'date-fns';
export function isLicenceExpiring(daysUntilExpiry) {
    return daysUntilExpiry <= 7;
}
/**
 * Whether the number of currently active users has hit the licence's cap.
 *
 * An undefined limit means the installation is uncapped (licences minted before
 * the concurrent-user limit existed stay unlimited).
 */
export function isConcurrentUserLimitReached(activeUsers, limit) {
    if (limit === undefined)
        return false;
    return activeUsers >= limit;
}
export function getDaysUntilLicenceStart(type, issuedAt) {
    if (type === 'lifetime' || !issuedAt)
        return -1;
    const now = Date.now();
    const daysUntilStart = differenceInCalendarDays(issuedAt, now);
    return daysUntilStart;
}
export function getDaysUntilLicenceExpiry(type, expiresAt) {
    if (type === 'lifetime' || !expiresAt)
        return Number.POSITIVE_INFINITY;
    const now = Date.now();
    const daysUntilExpiry = differenceInCalendarDays(expiresAt, now);
    return daysUntilExpiry;
}
export function redactLicenceJWT(jwt) {
    const length = jwt.length;
    const visibleLength = 6;
    return jwt.slice(0, visibleLength).padEnd(length / 12 - visibleLength, '*');
}
//# sourceMappingURL=licences.js.map